"use client";

import React, { useEffect, useRef, useState } from "react";
import { ArrowRight, BookOpen } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExploreDeepWaters() {
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const sectionRef = useRef<HTMLElement>(null);
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!sectionRef.current) return;
      const {
        clientX,
        clientY
      } = e;
      const {
        innerWidth,
        innerHeight
      } = window;
      const x = (clientX / innerWidth - 0.5) * 40;
      const y = (clientY / innerHeight - 0.5) * 40;
      setMousePos({
        x,
        y
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section data-section-id="224660" id="potencia-para-tu-cosecha" ref={sectionRef} className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-[-5%] w-[110%] h-[110%] bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647820/img/tractor_heavy_duty_field.png)] transition-transform duration-300 ease-out will-change-transform" style={{
      transform: `translate(${mousePos.x}px, ${mousePos.y}px) scale(1.02)`
    }} />
      
      {}
      <div className="absolute inset-0 bg-black/60 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />

      {}
      <div ref={contentRef} className={`relative z-10 flex flex-col items-center text-center px-6 w-full max-w-4xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        

        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-white mb-6 tracking-tighter drop-shadow-2xl font-bold leading-tight uppercase">
          Potencia Sin Límites
        </h1>
        
        <p className="font-default text-lg md:text-xl text-white/80 max-w-[600px] mb-10 drop-shadow-md leading-relaxed">En ARRELS impulsamos tu producción con arriendo de maquinaria agrícola, desde retroexcavadoras, mini, grúas horquillas, tractores y autocargables con despacho directo.</p>
        
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="bg-[var(--primary)] hover:bg-[var(--primary)]/90 text-[var(--primary-foreground)] border-none rounded-sm px-8 h-14 text-base font-bold shadow-xl shadow-black/40 transition-all">
            <Link to="https://maquinaarrels.com/maquinaria/">
              Ver Flota
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
          
          <Button asChild size="lg" variant="outline" className="bg-white/5 border-white/30 text-white hover:bg-white/20 hover:text-white rounded-sm px-8 h-14 text-base backdrop-blur-md transition-all">
            <Link to="#">
              <BookOpen className="mr-2 size-5" />
              Ver en Acción
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}